// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1RyYC","row":"Node_row__21z0L","label":"Node_label__2HM5S","footer":"Node_footer__3g7yD"};